import type { PopupType } from "../types";
import AudioCaptureSender from "./AudioCaptureSender";
import { Button } from "@mantine/core";
import { useParams } from "react-router-dom";
import { useUpdateSonometerMutation } from "sonometer/api/sonometer.api";
import { Sonometer } from "../types/sonometer.model"; // Needed for the Sonometer type
import { SonometerService } from "../../services/sonometer.service";

const ControlPanel: React.FC = () => {
  const { sonometerId } = useParams<{ sonometerId: string }>();
  const [updateSonometer, { isLoading, error }] = useUpdateSonometerMutation();
  const sonometerService = new SonometerService();

  const buttons: { id: PopupType; label: string }[] = [
    { id: "texte1", label: "Text 1" },
    { id: "preranking", label: "Pre Ranking" },
    { id: "texte2", label: "Text 2" },
    { id: "live_sound", label: "Live Sound" },
    { id: "live_record", label: "Live Record" },
    { id: "scoreRevelation", label: "Score Revelation" },
    { id: "animation", label: "Animation" },
    { id: "ranking", label: "Final Ranking" },
    { id: "texte3", label: "Text 3" },
  ];

  const handleButtonClick = async (view: PopupType) => {
    console.log(`🖱️ [CONTROL PANEL] Button clicked: ${view}`);

    if (!sonometerId) {
      console.error("❌ [CONTROL PANEL] Sonometer ID is missing.");
      alert("Sonometer ID is missing. Cannot update screen.");
      return;
    }

    try {
      // Fetch the latest sonometer data directly using SonometerService
      const latestSonometer =
        await sonometerService.getSonometerById(sonometerId);

      if (!latestSonometer) {
        console.error(
          "❌ [CONTROL PANEL] Failed to fetch latest sonometer data."
        );
        alert("Failed to get latest sonometer data. Cannot update screen.");
        return;
      }

      const updatedSonometer: Sonometer = {
        ...latestSonometer, // Use the latest fetched data
        screen: view,
      };
      await updateSonometer(updatedSonometer).unwrap();
      console.log(`✅ [CONTROL PANEL] Sonometer screen updated to: ${view}`);
    } catch (err: any) {
      console.error(
        "🚨 [CONTROL PANEL] Failed to update sonometer screen:",
        err
      );
      alert(
        `Failed to update sonometer screen: ${err.message || "Unknown error"}`
      );
    }
  };

  return (
    <div className="p-8 flex flex-col items-center justify-center">
      {error && (
        <div className="text-red-500 mb-4">
          Error: {error.message || "Failed to update screen."}
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {buttons.map((button) => (
          <Button
            key={button.id}
            onClick={() => handleButtonClick(button.id)}
            disabled={isLoading}
            className={`
              bg-button-admin
            
            `}
          >
            {button.label}
          </Button>
        ))}
      </div>
      <AudioCaptureSender />
    </div>
  );
};

export default ControlPanel;
